import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleStatus } from '../enums/admin-box-sale-status';

export class AdminBoxSaleCollectionItem {
  public constructor(
    private readonly data: {
      boxId: Guid;
      boxName: string;
      canBeApproved: boolean;
      canBeArchived: boolean;
      canBeBoxViewed: boolean;
      canBeEdited: boolean;
      canBeGroupsEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      canHideContent: boolean;
      canPublicContent: boolean;
      createdAt: Date;
      featuredFileAlt?: Nillable<string>;
      featuredFileUrl?: Nillable<string>;
      id: Guid;
      isContentPublic: boolean;
      status: AdminBoxSaleStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get boxName(): string {
    return this.data.boxName;
  }

  public get boxId(): Guid {
    return this.data.boxId;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get status(): AdminBoxSaleStatus {
    return this.data.status;
  }

  public get isContentPublic(): boolean {
    return this.data.isContentPublic;
  }

  public get featuredFileUrl(): Nillable<string> {
    return this.data.featuredFileUrl;
  }

  public get featuredFileAlt(): Nillable<string> {
    return this.data.featuredFileAlt;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeGroupsEdited(): boolean {
    return this.data.canBeGroupsEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeApproved(): boolean {
    return this.data.canBeApproved;
  }

  public get canBeArchived(): boolean {
    return this.data.canBeArchived;
  }

  public get canBeBoxViewed(): boolean {
    return this.data.canBeBoxViewed;
  }

  public get canHideContent(): boolean {
    return this.data.canHideContent;
  }

  public get canPublicContent(): boolean {
    return this.data.canPublicContent;
  }
}
